export class BatchStoreUpdateMiddleware {
    currentListeners: Array<() => void> = [];
    receivedNotificationCount: number = 0;
    actions: Array<any> = [];
    logging = false;

    subscribe(listener: () => void) {

        if (typeof listener !== `function`)
            throw new Error(`Invalid listener, expected a function`);

        let isSubscribed = true;

        this.currentListeners.push(listener);

        return () => {

            if (!isSubscribed)
                return;

            this.currentListeners.splice(this.currentListeners.indexOf(listener), 1);

            isSubscribed = false;

        };

    }

    notifyListeners() {
        if (!this.receivedNotificationCount) {
            return;
        }
        if (this.logging) {
            console.log('store update count:' + this.receivedNotificationCount, this.actions);
        }
        this.receivedNotificationCount = 0;
        this.actions = [];

        /***
         *  делаем копию, что если вдруг кто-то подпишеться по время listeners[t]();, мы его не вызвали.
         */
        let listeners = this.currentListeners.slice();

        for (let t = 0; t < listeners.length; t++) {
            try {
                listeners[t]();
            } catch (e){
                console.error(e);
            }
        }

    }

    listener() {
        this.receivedNotificationCount ++;
    }

    getMiddleware() {
        let _notifyListeners = () =>{
            this.notifyListeners();
        };
        let addAction = (action: any) =>{
            if (!(action instanceof Function)) {
                this.actions.push(action);
            }
        }
        return () => {
            let step = 0;
            let core = (next: any) => (action: any) => {
                addAction(action);
                step = step + 1;
                let store;
                try {
                     store = next(action);
                } catch (e){
                    console.error(e);
                }
                step = step - 1;
                if (!step) {
                    _notifyListeners();
                }
                return store;
            }
            return core;
        };
    }

    setLogging(log: boolean = true) {
        this.logging = log;
    }
}
